// extracted by mini-css-extract-plugin
module.exports = {"canvas":"app_canvas__yX9Dr","container":"app_container__NpoNw"};